


















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const recruitFormStore = namespace('RecruitFormStore')

@Component
export default class RecruitFormsUsher extends Vue {
  @Prop() private show

  @recruitFormStore.State
  private forms

  @recruitFormStore.Getter
  private createdForms

  protected curPathName = ''

  @Watch('$route')
  routeUpdated (r) {
    this.curPathName = r.name
  }

  protected refresh = 1

  get curFormIdx () {
    return this.createdForms.findIndex(fd => fd.name === this.curPathName)
  }

  get curHasError () {
    return this.createdForms.find(fd => fd.name === this.curPathName)?.error?.length
  }

  get canNext () {
    return this.curFormIdx < this.createdForms.length - 1
  }

  get canPrev () {
    return this.curFormIdx > 0
  }

  get nextForm () {
    return this.canNext ? this.createdForms[this.curFormIdx + 1] || { displayName: '...' } : { displayName: '...' }
  }

  get prevForm () {
    return this.canPrev ? this.createdForms[this.curFormIdx - 1] || { displayName: '...' } : { displayName: '...' }
  }

  goNext () {
    if (!this.canNext) return
    this.$router.push({ name: this.nextForm.name })
    this.refresh++
  }

  goPrev () {
    if (!this.canPrev) return
    this.$router.push({ name: this.prevForm.name })
    this.refresh++
  }

  setIndicate (sec) {
    console.log(sec)
    this.$emit('indicate', sec)
  }

  created () {
    this.curPathName = this.$router.currentRoute.name
  }
}
